import { Button, ButtonProps, Spinner } from "@heroui/react";
import React from 'react';

interface CustomButtonProps extends ButtonProps {
  styleClasses?: string;
}

const CustomButton: React.FC<CustomButtonProps> = ({
  children,
  size,
  variant,
  startContent,
  styleClasses,
  isLoading,
  ...props
}) => {
  const defaultStyles = '!border-1 border-solid !border-[#e7e7e7]';
  const styles = styleClasses || defaultStyles;
  return (
    <Button
      className={`w-full px-[12px] ${styles}`}
      size={size || 'lg'}
      variant={variant || 'bordered'}
      {...props}
    >
      <div className="w-full">
        {startContent && <div className="float-left">{startContent}</div>}
        <span>
          {isLoading ? <Spinner size="sm" color="default" /> : children}
        </span>
      </div>
    </Button>
  );
};

CustomButton.defaultProps = {
  styleClasses: '',
};

export default CustomButton;
